import { Collab } from "../../components/collab";
import { Footer } from "../../components/footer";
import { Navbar } from "../../components/navbar";
import { ProjectDescription } from "../../components/ProjectDescription";
import { ProjectHeader } from "../../components/ProjectHeader";
import { homeWorkData } from "../../json/HomeWorkData"

export const ChickFilEh = () => {
   const findProjectByTitle = (title) => (
      homeWorkData.find(project => project.title === title)
   );
   
   const project = findProjectByTitle("Chick-Fil-Eh");

   return (
		<>
			<Navbar />
			<ProjectHeader props={project} imgNumber={0} />
			{/* Desc */}
			<ProjectDescription props={project} />
			{/* Images */}
			<section className="px-[16px] md:px-[32px] lg:px-[192px] bg-gradient-to-b from-[#FCFCFC] to-[#ebf3f3] pt-[1.5rem] pb-[8rem] md:pb-[9rem] flex flex-col gap-[0.75rem] md:gap-[1.25rem]">
				<img
					src={project.imgData[3]}
					alt=""
					className="rounded-lg w-full"
				/>
				{/* <img
               src={project.imgData[2]}
               alt=""
               className="rounded-lg w-full"
            /> */}
				<div className="grid grid-cols-1 md:grid-cols-2 gap-[0.75rem] md:gap-[1.25rem]">
					<img
						src={project.imgData[1]}
						alt=""
						className="cols-span-1 rounded-lg h-[65vh] w-full md:h-full object-cover"
					/>
					<img
						src={project.imgData[2]}
						alt=""
						className="cols-span-1 rounded-lg h-[80vh] w-full md:h-full object-cover"
					/>
				</div>
				{/* <img
               src={project.imgData[5]}
               alt=""
               className="rounded-lg w-full"
            /> */}
			</section>
			<Collab />
			<Footer />
		</>
	);
}